export class LookupItem {
  constructor(public key: any, public value: string) { }
}
